import React from 'react';
import { Link } from '@fluentui/react';
import { GetArticleSummaryDto } from 'generated/article-backend';
import { getParagraphFromContent } from 'app/components/helpers';
import { useGenerateFileSasToken } from 'app/services/article-api';
import { getBlobFileNameFromString } from 'app/utils/blobStorageHelpers';
import { BlobStorageContainer, Entity } from 'app/utils/constants';
import DOMPurify from 'dompurify';

interface IProps {
    index: number;
    article: GetArticleSummaryDto;
    openThisTraining: Function;
    activeTrainingId: string;
}

const VideoSliderCard: React.FC<IProps> = (props) => {
    const { index, article, openThisTraining, activeTrainingId } = props;
    const { data: thumbnail } = useGenerateFileSasToken(Entity.ARTICLE, BlobStorageContainer.ARTICLE_FILES, getBlobFileNameFromString(article?.thumbnail));

    return (
        <>
            <div key={index} className={`item ${activeTrainingId === article?.id ? 'active' : ''}`}>
                <Link onClick={() => openThisTraining(article?.id)}>
                    <div className="video-thumb">
                        <div
                            className="video-thumb"
                            style={{
                                backgroundImage: `url(${ thumbnail })`
                            }}></div>
                        <span className="play-button">
                            <i className="ms-Icon ms-Icon--BoxPlaySolid"></i>
                        </span>
                    </div>
                    <div className="details">
                        <h5 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article?.title) }}></h5>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(getParagraphFromContent(article.content))
                            }}></div>
                    </div>
                </Link>
            </div>
        </>
    );
};

export default VideoSliderCard;
